import { classNames } from "@lib/HtmlUtil"
import React from "react"
import { Select, SelectProps } from "./Select"

export function RoundedSelect({ className, ...props }: SelectProps): JSX.Element {
    return <Select className={classNames("select--rounded", className)} {...props} />
}
